/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var ScreenIcon = createIcon({
  name: 'ScreenIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M1024 146.286v731.429h-1024v-731.429h438.857v-73.143h-219.429v-73.143h585.143v73.143h-219.429v73.143h438.857zM146.286 731.428h731.429v-438.857h-731.429v438.857z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});
export default ScreenIcon;